export default __webpack_public_path__ + "static/media/more-horizontal.94dbc10c.svg";